module.exports = __webpack_public_path__ + "img/two-group-paired.9732f785.svg";